var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 16.2353V17.75H2.26472C3.49097 17.75 4.1041 17.75 4.65541 17.5216C5.20673 17.2933 5.64027 16.8597 6.50736 15.9926L16.3713 6.12868C17.2539 5.24612 17.6951 4.80483 17.7439 4.26325C17.752 4.17372 17.752 4.08364 17.7439 3.99411C17.6951 3.45253 17.2539 3.01124 16.3713 2.12868C15.4887 1.24612 15.0474 0.804833 14.5059 0.756053C14.4163 0.747983 14.3263 0.747983 14.2367 0.756053C13.6951 0.804833 13.2539 1.24612 12.3713 2.12868L2.50736 11.9926C1.64027 12.8597 1.20673 13.2933 0.97836 13.8446C0.75 14.3959 0.75 15.009 0.75 16.2353Z",
    stroke: "#0DB5B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_Icon.3a06c9d9df661ea6b903a17332871e98.svg";
export { ForwardRef as ReactComponent };